import { REDUCE_ALLOW_EDIT } from '../../constants/actions/policy';

export function reduceAllowEdit(payload) {
    return {
        type: REDUCE_ALLOW_EDIT,
        payload,
    };
}
